import * as generatedServices from '../generatedServices';
import { getValidResponseDataOrThrow } from '../helpers';
import { CalculationDetails, CalculationInput, CalculationOutput, CalculationParameter } from '../types';

const getSafeCalculationParameter = (param: Partial<CalculationParameter>): CalculationParameter => {
  return {
    name: param.name || '',
    type: param.type || '',
    isRequired: param.isRequired,
  };
};

export class CalculationService {
  readonly unvalidatedClient: generatedServices.GeneratedCalculationService = new generatedServices.GeneratedCalculationService();
  constructor(domain?: string) {
    this.unvalidatedClient = new generatedServices.GeneratedCalculationService(domain);
  }

  getCalculationDetails = async (clientId: string, modelId: string): Promise<CalculationDetails> => {
    const response = await this.unvalidatedClient.getCalculationsById({ clientId, id: modelId });
    const calculationDetails = getValidResponseDataOrThrow(response);
    return {
      inputParameters: (calculationDetails.inputParameters || []).map(getSafeCalculationParameter) || [],
      outputParameters: (calculationDetails.outputParameters || []).map(getSafeCalculationParameter) || [],
    };
  };

  performModelCalculation = async (
    clientId: string,
    modelId: string,
    inputs: CalculationInput[]
  ): Promise<CalculationOutput[]> => {
    const response = await this.unvalidatedClient.postCalculationsByModelId({
      clientId,
      modelId,
      body: { inputParameters: inputs },
    });

    const calculationOutput = getValidResponseDataOrThrow(response) || [];
    return calculationOutput.map((c) => ({
      name: c?.name || '',
      value: c?.value,
    }));
  };
}
